<footer class="ade-footer">
  <div class="ade-footer__top-line"></div>

  <div class="ade-footer__inner">
    <h2 class="ade-footer__heading font-serif mb-8 contactos-title">
      {{ "CONTACTOS" | transloco }}
    </h2>

    <article class="ade-footer__col ade-footer__col--info">
      <h3 class="ade-footer__title">{{ contactName }}</h3>
      <p
        class="ade-footer__tagline"
        *ngIf="ft?.tagline"
        [innerHTML]="ft?.tagline"
      ></p>
      <p class="ade-footer__line" *ngIf="profile?.address">
        {{ profile?.address }}
      </p>
      <p class="ade-footer__label">
        {{ "Atendimento por marcação" | transloco }}
      </p>
      <h3 class="ade-footer__title ade-footer__title--phone">
        <a class="ade-footer__phone" [href]="'tel:' + contactPhone">{{
          contactPhone
        }}</a>
      </h3>
      <a class="ade-footer__email" [href]="'mailto:' + contactEmail">{{
        contactEmail
      }}</a>
    </article>

    <div class="ade-footer__col ade-footer__col--map">
      <iframe
        class="ade-footer__map-frame"
        title="Mapa"
        [src]="mapUrl"
        loading="lazy"
        allowfullscreen
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>

    <form
      class="ade-footer__col ade-footer__col--form"
      [formGroup]="contactForm"
      (ngSubmit)="submit()"
      novalidate
    >
      <label class="ade-footer__field">
        <input
          type="text"
          formControlName="name"
          [placeholder]="'Nome' | transloco"
          required
        />
      </label>
      <label class="ade-footer__field">
        <input
          type="email"
          formControlName="email"
          [placeholder]="'E-mail' | transloco"
          required
        />
      </label>
      <label class="ade-footer__field">
        <input
          type="text"
          formControlName="phone"
          [placeholder]="'Telefone' | transloco"
        />
      </label>
      <label class="ade-footer__field">
        <textarea
          rows="4"
          formControlName="message"
          [placeholder]="'Mensagem' | transloco"
          required
        ></textarea>
      </label>
      <button type="submit" class="ade-footer__submit" [disabled]="sending">
        {{ (sending ? "A enviar..." : "Enviar") | transloco }}
      </button>
      <p
        *ngIf="feedback"
        class="ade-footer__form-feedback"
        [class.is-error]="feedbackError"
      >
        {{ feedback | transloco }}
      </p>
    </form>

    <div class="ade-footer__socials" aria-label="Social links">
      <a
        *ngIf="sl?.facebook"
        [href]="sl.facebook"
        target="_blank"
        rel="noopener noreferrer"
        class="ade-footer__social-link"
        aria-label="Facebook"
      >
        <span class="ade-footer__social-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
            ></path>
          </svg>
        </span>
      </a>
      <a
        *ngIf="sl?.instagram"
        [href]="sl.instagram"
        target="_blank"
        rel="noopener noreferrer"
        class="ade-footer__social-link"
        aria-label="Instagram"
      >
        <span class="ade-footer__social-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
          </svg>
        </span>
      </a>
      <a
        *ngIf="sl?.youtube"
        [href]="sl.youtube"
        target="_blank"
        rel="noopener noreferrer"
        class="ade-footer__social-link"
        aria-label="YouTube"
      >
        <span class="ade-footer__social-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"
            ></path>
            <path d="m10 15 5-3-5-3z"></path>
          </svg>
        </span>
      </a>
      <a
        *ngIf="whatsappUrl"
        [href]="whatsappUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="ade-footer__social-link"
        aria-label="WhatsApp"
      >
        <span class="ade-footer__social-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
            ></path>
          </svg>
        </span>
      </a>
      <a
        *ngIf="sl?.linkedin"
        [href]="sl.linkedin"
        target="_blank"
        rel="noopener noreferrer"
        class="ade-footer__social-link"
        aria-label="LinkedIn"
      >
        <span class="ade-footer__social-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
            ></path>
            <rect width="4" height="12" x="2" y="9"></rect>
            <circle cx="4" cy="4" r="2"></circle>
          </svg>
        </span>
      </a>
    </div>
  </div>

  <div class="ade-footer__bottom">
    <span *ngIf="copyright; else defaultCopyright"
      >{{ copyright }} | Engineered by Motorbest.pt</span
    >
    <ng-template #defaultCopyright>
      <span
        >© {{ currentYear }} {{ contactName | uppercase }}.
        {{ "TODOS OS DIREITOS RESERVADOS." | transloco }} | Engineered by
        Motorbest.pt</span
      >
    </ng-template>
    <span class="ade-footer__legal">
      <a
        *ngIf="privacyHref"
        class="ade-footer__legal-link"
        [href]="privacyHref"
        >{{ "Política de Privacidade" | transloco }}</a
      >
      <a *ngIf="termsHref" class="ade-footer__legal-link" [href]="termsHref">{{
        "Termos e Condições" | transloco
      }}</a>
      <a
        class="ade-footer__legal-link"
        role="button"
        tabindex="0"
        (click)="manageCookies()"
        (keydown.enter)="manageCookies()"
        >{{ "Manage cookies" | transloco }}</a
      >
    </span>
  </div>
</footer>
